import { env } from "./EnvironmentConfig";

export const APP_NAME = "Hse";
export const API_BASE_URL = env.API_ENDPOINT_URL;
